import { faCloudDownload } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Loader from '@pickleballinc/features/src/Loader/Loader';
import { Button } from '@pickleballinc/react-ui';
import clsx from 'clsx';

interface ExportRankingButtonProps {
  onExport: () => void;
  isExporting: boolean;
  // Tailwind bg-* class for the fullscreen loader. Defaults to the WPR green;
  // pass a brand color (e.g. 'bg-brand-700/90') on the PPA World Rankings page.
  loaderBackgroundColor?: string;
  // Extra classes for the button, e.g. to make it full-width on mobile.
  className?: string;
}

export const ExportRankingButton = ({
  onExport,
  isExporting,
  loaderBackgroundColor = 'bg-wpr-600/90',
  className,
}: ExportRankingButtonProps) => {
  return (
    <>
      <Button
        onClick={onExport}
        disabled={isExporting}
        variant='secondary'
        className={clsx('flex gap-2 !px-3 !py-2 !text-sm !border-gray-300', className)}
      >
        <FontAwesomeIcon icon={faCloudDownload} />
        {isExporting ? 'Exporting…' : 'Export'}
      </Button>
      {isExporting ? <Loader backgroundColor={loaderBackgroundColor} /> : null}
    </>
  );
};
